import { user } from 'contexts/userContext';

import { UserSettingsRequest } from '../models/userSettings';

type RequestInit = {
	method: string;
	headers: Record<string, string>;
	body?: string;
	keepalive?: boolean;
};

const getParams = (
	email: string,
	latestReadMessageDate: string,
	token: string
): RequestInit => ({
	method: 'PUT',
	headers: {
		'Content-Type': 'application/json',
		Authorization: `bearer ${token}`
	},
	body: JSON.stringify({
		email,
		latestReadMessageDate
	} as UserSettingsRequest),
	keepalive: true
});

const fetcher = async (
	userSettingsId: string,
	email: string,
	latestReadMessageDate: string
): Promise<void> => {
	if (user?.token && userSettingsId) {
		fetch(
			`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalUserSettingsId.replace('{userSettingsId}', userSettingsId)}`,
			getParams(email, latestReadMessageDate, user?.token)
		);
	}
};

export async function updateSignalsSettings(
	userSettingsId: string,
	email: string,
	latestReadMessageDate: string
): Promise<void> {
	return fetcher(userSettingsId, email, latestReadMessageDate);
}
